var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.375 16.2774C30.6717 16.583 29.9275 16.7843 29.166 16.875C29.9663 16.4064 30.5681 15.6619 30.8586 14.7813C30.102 15.2237 29.2756 15.5341 28.4148 15.6992C28.0524 15.3194 27.6165 15.0172 27.1336 14.811C26.6507 14.6048 26.1309 14.499 25.6059 14.5C23.4801 14.5 21.7598 16.1953 21.7598 18.2852C21.7583 18.5759 21.7916 18.8657 21.859 19.1484C20.3346 19.077 18.842 18.6881 17.4766 18.0067C16.1111 17.3254 14.9029 16.3665 13.9293 15.1914C13.5877 15.7672 13.4071 16.4242 13.4062 17.0938C13.4062 18.4063 14.091 19.5664 15.125 20.2461C14.5124 20.2316 13.9123 20.0694 13.3758 19.7734V19.8203C13.3758 21.6563 14.7039 23.1836 16.4617 23.5313C16.1312 23.6194 15.7905 23.664 15.4484 23.6641C15.2057 23.6645 14.9635 23.6409 14.7254 23.5938C15.2141 25.0977 16.6363 26.1914 18.3211 26.2227C16.9521 27.2777 15.2713 27.848 13.543 27.8438C13.2362 27.8433 12.9297 27.825 12.625 27.7891C14.3833 28.9118 16.4271 29.5057 18.5133 29.5C25.5977 29.5 29.468 23.7305 29.468 18.7266C29.468 18.5625 29.4637 18.3984 29.4559 18.2383C30.2071 17.7039 30.857 17.0399 31.375 16.2774Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.8d210e0a.svg";
export { ForwardRef as ReactComponent };